var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkbox-blank",
    "data-name": "checkbox-blank",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".checkbox-blank-cls{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Checkbos",
    "data-name": "Rectangle Checkbos"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "checkbox-blank-cls",
    x: 1.9999,
    y: 1.97268,
    width: 20,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001,21.97266h-10a5.00589,5.00589,0,0,1-5-5v-10a5.00588,5.00588,0,0,1,5-5h10a5.00589,5.00589,0,0,1,5,5v10A5.00589,5.00589,0,0,1,17.0001,21.97266Zm-10-19a4.00426,4.00426,0,0,0-4,4v10a4.00427,4.00427,0,0,0,4,4h10a4.00428,4.00428,0,0,0,4-4v-10a4.00427,4.00427,0,0,0-4-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBlank);
export default __webpack_public_path__ + "static/media/checkbox-blank.09166533dc45ae2d41565b1b5ce898d4.svg";
export { ForwardRef as ReactComponent };